import { broadcast } from '@/broadcast';
import { ERROR_TYPE } from '@services/ModalParameterContext';
import { computed, Ref, ref } from '@vue/composition-api';

/**
 * 旧パラメータ起動かどうかを示すグローバルストア。
 * これはservice_type, modal_modeを跨いで共有される。
 */
const isLegacyAtoneRef = ref<boolean | undefined>(undefined);

/**
 * モーダルの起動パラメータが統合インターフェイスタイプか旧パラメータタイプかを管理するためのglobalStoreに対するアクセスを提供します。
 *
 * atoneの各サービスのbridgeで、start時に必ず値をセットしてください。セットした値はモーダルが閉じるまで変更できません。
 * モーダルが閉じられると、セットされた値はクリアされます。
 *
 * @param value 引数を与えた場合、管理されたisLegacyの値をその通りに設定します。
 * @returns 現在が旧パラメータ起動かどうかを示すref値です。更新できません。
 */
const useIsLegacy = (): [isLegacy: Ref<boolean>, setIsLegacy: (isLegacy: boolean) => void] => {
  const setIsLegacy = (value: boolean) => {
    if (typeof isLegacyAtoneRef.value === 'boolean' && isLegacyAtoneRef.value !== value) {
      // isLegacyを反転させるのは加盟店エラーとする。
      const error = new Error(ERROR_TYPE.REQUEST_EXCEPTION.name);
      error.message = '共通IFパラメータモードと旧Atone互換パラメータモードを相互運用することはできません。';
      broadcast.send({
        type: 'JS_ERROR',
        payload: {
          name: error.name,
          message: error.message,
          stack: error.stack,
        },
      });
    } else {
      isLegacyAtoneRef.value = value;
    }
  };

  const computedIsLegacyAtone = computed(() => isLegacyAtoneRef.value || false);

  return [computedIsLegacyAtone, setIsLegacy] as const;
};

export default useIsLegacy;
